import { animate, animation, style, transition, trigger, useAnimation } from '@angular/animations';
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, ElementRef, NgZone, Renderer2, ViewRef, DOCUMENT } from '@angular/core';
import { PrimeNGConfig } from 'prime-ng-old/api';
import { ConfirmDialogService } from './confirm-dialog.service';
import { ConfirmDialog as ConfirmDialogBase } from 'prime-ng-old/confirmdialog';
import { DomHandler } from 'prime-ng-old/dom';
import { UiButtonComponent } from '../button';
import { UiIconsModule } from '../icons';
import { UiFooterComponent } from '../shared';
import * as i0 from "@angular/core";
import * as i1 from "./confirm-dialog.service";
import * as i2 from "prime-ng-old/api";
import * as i3 from "@angular/common";
import * as i4 from "../icons/icon.component";
const _c0 = ["content"];
const _c1 = [[["ui-footer"]]];
const _c2 = ["ui-footer"];
const _c3 = a0 => ({
  "p-dialog p-confirm-dialog p-component": true,
  "p-dialog-rtl": a0
});
const _c4 = (a0, a1) => ({
  transform: a0,
  transition: a1
});
const _c5 = a0 => ({
  value: "visible",
  params: a0
});
const _c6 = a0 => ({
  $implicit: a0
});
const _c7 = () => ({
  "p-dialog-header-icon p-dialog-header-close p-link": true
});
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_1_ng_container_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_1_ng_container_0_Template, 1, 0, "ng-container", 5);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headlessTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c6, ctx_r1.confirmation));
  }
}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵtemplate(1, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_0_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.headerTemplate);
  }
}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("id", ctx_r1.getAriaLabelledBy());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.option("header"));
  }
}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_1_Conditional_3_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.close($event));
    })("keydown.enter", function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_1_Conditional_3_Template_button_keydown_enter_0_listener($event) {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.close($event));
    });
    i0.ɵɵelement(1, "ui-icon", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction0(2, _c7));
    i0.ɵɵattribute("aria-label", ctx_r1.closeAriaLabel);
  }
}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 6);
    i0.ɵɵconditionalCreate(1, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_1_Conditional_1_Template, 2, 2, "span", 12);
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵconditionalCreate(3, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_1_Conditional_3_Template, 2, 3, "button", 14);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.option("header") ? 1 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.closable ? 3 : -1);
  }
}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ui-icon", 8);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngClass", "p-confirm-dialog-icon")("icon", ctx_r1.option("icon"));
  }
}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 9);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("innerHTML", ctx_r1.option("message"), i0.ɵɵsanitizeHtml);
  }
}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_6_0_ng_template_0_Template(rf, ctx) {}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_6_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_6_0_ng_template_0_Template, 0, 0, "ng-template");
  }
}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_6_0_Template, 1, 0, null, 5);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.messageTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction1(2, _c6, ctx_r1.confirmation));
  }
}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_7_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵprojection(1);
    i0.ɵɵtemplate(2, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_7_ng_container_2_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r1.footerTemplate);
  }
}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_8_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_8_Conditional_1_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.accept());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵclassMap(ctx_r1.option("acceptButtonStyleClass"));
    i0.ɵɵproperty("icon", "check")("label", ctx_r1.acceptButtonLabel)("ngClass", "p-confirm-dialog-accept");
    i0.ɵɵattribute("aria-label", ctx_r1.acceptAriaLabel);
  }
}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_8_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 20);
    i0.ɵɵlistener("click", function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_8_Conditional_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r1 = i0.ɵɵnextContext(5);
      return i0.ɵɵresetView(ctx_r1.reject());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵclassMap(ctx_r1.option("rejectButtonStyleClass"));
    i0.ɵɵproperty("icon", "times")("label", ctx_r1.rejectButtonLabel)("ngClass", "p-confirm-dialog-reject");
    i0.ɵɵattribute("aria-label", ctx_r1.rejectAriaLabel);
  }
}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵconditionalCreate(1, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_8_Conditional_1_Template, 1, 6, "button", 17);
    i0.ɵɵconditionalCreate(2, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_8_Conditional_2_Template, 1, 6, "button", 18);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.option("acceptVisible") ? 1 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.option("rejectVisible") ? 2 : -1);
  }
}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵconditionalCreate(0, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_0_Template, 2, 1, "div", 6);
    i0.ɵɵconditionalCreate(1, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_1_Template, 4, 2, "div", 6);
    i0.ɵɵelementStart(2, "div", 7, 0);
    i0.ɵɵconditionalCreate(4, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_4_Template, 1, 2, "ui-icon", 8);
    i0.ɵɵconditionalCreate(5, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_5_Template, 1, 1, "span", 9);
    i0.ɵɵconditionalCreate(6, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_6_Template, 1, 4);
    i0.ɵɵelementEnd();
    i0.ɵɵconditionalCreate(7, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_7_Template, 3, 1, "div", 10);
    i0.ɵɵconditionalCreate(8, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Conditional_8_Template, 3, 2, "div", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵconditional(ctx_r1.headerTemplate ? 0 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.headerTemplate ? 1 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.option("icon") ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.messageTemplate ? 5 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.messageTemplate ? 6 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.footer || ctx_r1.footerTemplate ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(!ctx_r1.footer && !ctx_r1.footerTemplate ? 8 : -1);
  }
}
function UiConfirmDialogComponent_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 4);
    i0.ɵɵlistener("@animation.start", function UiConfirmDialogComponent_Conditional_0_Conditional_1_Template_div_animation_animation_start_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onAnimationStart($event));
    })("@animation.done", function UiConfirmDialogComponent_Conditional_0_Conditional_1_Template_div_animation_animation_done_0_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.onAnimationEnd($event));
    });
    i0.ɵɵconditionalCreate(1, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_1_Template, 1, 4, "ng-container")(2, UiConfirmDialogComponent_Conditional_0_Conditional_1_Conditional_2_Template, 9, 7);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r1.styleClass);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c3, ctx_r1.rtl))("ngStyle", ctx_r1.style)("@animation", i0.ɵɵpureFunction1(13, _c5, i0.ɵɵpureFunction2(10, _c4, ctx_r1.transformOptions, ctx_r1.transitionOptions)));
    i0.ɵɵattribute("aria-labelledby", ctx_r1.getAriaLabelledBy())("aria-modal", true);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.headlessTemplate ? 1 : 2);
  }
}
function UiConfirmDialogComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2);
    i0.ɵɵconditionalCreate(1, UiConfirmDialogComponent_Conditional_0_Conditional_1_Template, 3, 15, "div", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵclassMap(ctx_r1.maskStyleClass);
    i0.ɵɵproperty("ngClass", ctx_r1.getMaskClass());
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.visible ? 1 : -1);
  }
}
const showAnimation = animation([style({
  transform: '{{transform}}',
  opacity: 0
}), animate('{{transition}}', style({
  transform: 'none',
  opacity: 1
}))]);
const hideAnimation = animation([animate('{{transition}}', style({
  transform: '{{transform}}',
  opacity: 0
}))]);
/**
 * IMPORTANT: primeng ConfirmationService is REPLACED by custom ConfirmDialogService!
 * ConfirmDialogService DOES NOT extend ConfirmationService.
 */
export let UiConfirmDialogComponent = /*#__PURE__*/(() => {
  class UiConfirmDialogComponent extends ConfirmDialogBase {
    // pass custom ConfirmDialogService instead of ConfirmationService!
    constructor(el, renderer, confirmationService, zone, cd, config, document) {
      super(el, renderer, confirmationService, zone, cd, config, document);
      this.el = el;
      this.renderer = renderer;
      this.zone = zone;
      this.config = config;
      this.baseZIndex = 5000;
      this.acceptLabel = 'Ja';
      this.rejectLabel = 'Nein';
      this.icon = null;
      this.cd2 = cd;
      this.doc2 = document;
    }
    // was creating a ViewDestroyedError during detectChanges
    disableModality() {
      this.maskVisible = false;
      if (this.blockScroll) {
        DomHandler.removeClass(this.doc2.body, 'ui-overflow-hidden');
      }
      if (this.container && !this.cd2?.destroyed) {
        this.cd2.detectChanges();
      }
    }
    static {
      this.ɵfac = function UiConfirmDialogComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || UiConfirmDialogComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.ConfirmDialogService), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i2.PrimeNGConfig), i0.ɵɵdirectiveInject(DOCUMENT));
      };
    }
    static {
      this.ɵcmp = /*@__PURE__*/i0.ɵɵdefineComponent({
        type: UiConfirmDialogComponent,
        selectors: [["ui-confirmDialog"]],
        contentQueries: function UiConfirmDialogComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, UiFooterComponent, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.footer = _t.first);
          }
        },
        viewQuery: function UiConfirmDialogComponent_Query(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 7);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.contentViewChild = _t.first);
          }
        },
        inputs: {
          baseZIndex: "baseZIndex"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c2,
        decls: 1,
        vars: 1,
        consts: [["content", ""], [3, "class", "ngClass"], [3, "ngClass"], ["e2e-confirm-dialog", "", "role", "alertdialog", 3, "ngClass", "ngStyle", "class"], ["e2e-confirm-dialog", "", "role", "alertdialog", 3, "ngClass", "ngStyle"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "p-dialog-header"], [1, "p-dialog-content", "padded"], [3, "ngClass", "icon"], [1, "p-confirm-dialog-message", 3, "innerHTML"], [1, "p-dialog-footer"], [4, "ngTemplateOutlet"], [1, "p-dialog-title", 3, "id"], [1, "p-dialog-header-icons"], ["type", "button", "role", "button", 3, "ngClass"], ["type", "button", "role", "button", 3, "click", "keydown.enter", "ngClass"], ["icon", "times"], ["e2e-confirm-dialog-accept-button", "", "type", "button", "uiButton", "", 3, "icon", "label", "ngClass", "class"], ["e2e-confirm-dialog-reject-button", "", "type", "button", "uiButton", "", 3, "icon", "label", "ngClass", "class"], ["e2e-confirm-dialog-accept-button", "", "type", "button", "uiButton", "", 3, "click", "icon", "label", "ngClass"], ["e2e-confirm-dialog-reject-button", "", "type", "button", "uiButton", "", 3, "click", "icon", "label", "ngClass"]],
        template: function UiConfirmDialogComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c1);
            i0.ɵɵconditionalCreate(0, UiConfirmDialogComponent_Conditional_0_Template, 2, 4, "div", 1);
          }
          if (rf & 2) {
            i0.ɵɵconditional(ctx.maskVisible ? 0 : -1);
          }
        },
        dependencies: [CommonModule, i3.NgClass, i3.NgTemplateOutlet, i3.NgStyle, UiButtonComponent, UiIconsModule, i4.UiIconComponent],
        styles: ["@layer primeng{.p-dialog-mask{position:fixed;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;pointer-events:none}.p-dialog-mask.p-component-overlay{pointer-events:auto}.p-dialog{display:flex;flex-direction:column;pointer-events:auto;max-height:90%;transform:scale(1);position:relative}.p-dialog-content{overflow-y:auto;flex-grow:1}.p-dialog-header{display:flex;align-items:center;justify-content:space-between;flex-shrink:0}.p-dialog-draggable .p-dialog-header{cursor:move}.p-dialog-footer{flex-shrink:0}.p-dialog .p-dialog-header-icons{display:flex;align-items:center}.p-dialog .p-dialog-header-icon{display:flex;align-items:center;justify-content:center;overflow:hidden;position:relative}.p-fluid .p-dialog-footer .p-button{width:auto}.p-dialog-top .p-dialog,.p-dialog-bottom .p-dialog,.p-dialog-left .p-dialog,.p-dialog-right .p-dialog,.p-dialog-top-left .p-dialog,.p-dialog-top-right .p-dialog,.p-dialog-bottom-left .p-dialog,.p-dialog-bottom-right .p-dialog{margin:.75rem;transform:translateZ(0)}.p-dialog-maximized{transition:none;transform:none;width:100vw!important;height:100vh!important;top:0!important;left:0!important;max-height:100%;height:100%}.p-dialog-maximized .p-dialog-content{flex-grow:1}.p-dialog-left{justify-content:flex-start}.p-dialog-right{justify-content:flex-end}.p-dialog-top{align-items:flex-start}.p-dialog-top-left{justify-content:flex-start;align-items:flex-start}.p-dialog-top-right{justify-content:flex-end;align-items:flex-start}.p-dialog-bottom{align-items:flex-end}.p-dialog-bottom-left{justify-content:flex-start;align-items:flex-end}.p-dialog-bottom-right{justify-content:flex-end;align-items:flex-end}.p-dialog .p-resizable-handle{position:absolute;font-size:.1px;display:block;cursor:se-resize;width:12px;height:12px;right:1px;bottom:1px}.p-confirm-dialog .p-dialog-content{display:flex;align-items:center}}.p-dialog-mask{z-index:9000}.p-dialog-mask.p-dialog-mask-invisible{background-color:transparent;pointer-events:none}.p-dialog-wrapper{position:fixed;top:0;left:0;width:100%;height:100%;display:flex;justify-content:center;align-items:center;pointer-events:none}.p-dialog{pointer-events:auto;display:flex;flex-direction:column;width:800px;max-width:90%;border:var(--overlayContentBorder);border-color:var(--overlayContentBorderColor)}.p-dialog{padding:0;box-shadow:var(--dialogShadow)}.p-dialog .p-dialog-header{background-color:var(--panelHeaderAltBgColor);color:var(--panelHeaderAltTextColor);padding:1em;font-weight:400;border-bottom:0 none}.p-dialog .p-dialog-header .p-dialog-title{margin:0;float:none}.p-dialog .p-dialog-header .p-dialog-header-icon{color:var(--panelHeaderIconColor);border:0 none;padding:0;margin-left:.5em;transition:color .3s}.p-dialog .p-dialog-header .p-dialog-header-icon:hover{color:var(--panelHeaderIconHoverColor)}.p-dialog .p-dialog-content{background-color:var(--panelContentBgColor);color:var(--panelContentTextColor);border:var(--overlayContentBorder);border-color:var(--overlayContentBorderColor);padding:0;position:relative}.p-dialog .p-dialog-content.padded{padding:.571em 1em}.p-dialog .p-dialog-footer{border:0;border-color:transparent;border-top:0 none;background-color:var(--panelFooterBgColor);color:var(--panelFooterTextColor);padding:8px 10px;margin:0;text-align:right}.p-dialog .p-dialog-footer button{margin:0 .5em 0 0;width:auto}\n", ".p-dialog.p-confirm-dialog .p-dialog-content.padded{padding:1.5em}.p-dialog.p-confirm-dialog .p-dialog-content .p-confirm-dialog-icon{margin-right:10px}\n"],
        encapsulation: 2,
        data: {
          animation: [trigger('animation', [transition('void => visible', [useAnimation(showAnimation)]), transition('visible => void', [useAnimation(hideAnimation)])])]
        },
        changeDetection: 0
      });
    }
  }
  return UiConfirmDialogComponent;
})();